import { render, staticRenderFns } from "./RecorderVoiceModal.vue?vue&type=template&id=76981541"
import script from "./RecorderVoiceModal.vue?vue&type=script&lang=js"
export * from "./RecorderVoiceModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QDialog});
